import React from 'react';
import { Tooltip as AntTooltip } from 'antd';

type Placement =
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom';

interface TooltipProps {
  children: React.ReactNode;
  placement?: Placement;
  text: React.ReactNode | string;
  overlayWidth?: CSSSize | 'auto';
}

function Tooltip({ children, text, overlayWidth = 'auto', placement }: TooltipProps): JSX.Element {
  return (
    <AntTooltip
      overlayStyle={{ width: overlayWidth, maxWidth: '100%' }}
      overlayInnerStyle={{ whiteSpace: 'pre-line', maxWidth: overlayWidth }}
      title={text}
      placement={placement}
    >
      <>{children}</>
    </AntTooltip>
  );
}

export default Tooltip;
